<main class="main">
    <div class="container">
        <div class="pageHeader d-flex justify-content-between">
            <h1 class="mb-4">Missed Action Data Validation</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <div class="d-flex justify-content-end" style="margin-bottom: 15px;">
                    <div class="form-check me-3">
                        <input class="form-check-input" type="checkbox" id="wrapText" name="wrapText" [(ngModel)]="wrapText">
                        <label class="form-check-label">Wrap Text</label>
                    </div>
                    <button class="btn btn-primary smallBtn me-0" style="width: auto; margin-right: 1px" routerLink="/UploadMissedData">
                        Upload Missed Action Data
                    </button>
                </div>
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable': wrapText == true}">
                        <thead>
                            <tr>
                                <th style="width: 5%; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Job ID</span>
                                        <span (click)="sortData('JobID')"><i class="fa fa-sort"></i></span>
                                    </div>       
                                </th>
                                <th style="width: 5%; min-width: 300px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Missed Action File Name</span>
                                        <span (click)="sortData('MissedActionDataFileName')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Missed Action Start Date</span>
                                        <span (click)="sortData('MissedActionDataStartDate')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>Missed Action End Date</span>
                                        <span (click)="sortData('MissedActionDataEndDate')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">            
                                        <span>Status</span>
                                        <span (click)="sortData('Status')"><i class="fa fa-sort"></i></span>
                                    </div>
                                </th>
                                <th style="width: 5%; min-width: 200px;">
                                    Missed Action Data
                                </th>
                            </tr>
                            <tr>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID" [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.jobID"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID" [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.fileName"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID" [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.startDate"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID" [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.endDate"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID" [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.status"
                                                    (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="filteredData.length === 0">
                                <td colspan="6" class="text-center" style="color: red; padding-top: 70px; padding-bottom: 70px;">
                                    No Record Found
                                </td>
                            </tr>
                            <tr *ngFor="let missedActionData of filteredData">
                                <td style="width: 15%;" class="ellipsis" title="{{missedActionData?.JobID}}">
                                    {{missedActionData?.JobID}}
                                </td>
                                <td style="width: 15%;" class="ellipsis" title="{{missedActionData?.MissedActionDataFileName}}">
                                    <a [href]="missedActionData?.UploadedMissedActionFileURL">{{missedActionData?.MissedActionDataFileName}}</a>
                                </td>
                                <td style="width: 15%;" class="ellipsis" title="{{missedActionData?.MissedActionDataStartDate}}">
                                    {{missedActionData?.MissedActionDataStartDate}}
                                </td>
                                <td style="width: 15%;" class="ellipsis" title="{{missedActionData?.MissedActionDataEndDate}}">
                                    {{missedActionData?.MissedActionDataEndDate}}
                                </td>
                                <td style="width: 15%;" class="ellipsis" title="{{missedActionData?.Status}}">
                                    {{missedActionData?.Status}}
                                </td>
                                <td style="width: 15%;" class="ellipsis">
                                    <a [href]="missedActionData?.DownloadFile">Download</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row clear-fix col-12 mt-2">
                <div class="col-3 ps-4 d-flex">
                    <div class="form-floating p-1">
                        <select class="form-select form-control paginationDropdown" id="floatingSelect" [(ngModel)]="pagination.pageLength" (change)="GetUsersByPageLength()">
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                            <option value="500">500</option>
                            <option value="750">750</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>
                    <label for="floatingSelect" class="mt-2 pt-2 ms-2">Items per page</label>
                </div>
                <div class="col-9 m-0 float-right">
                    <div class="col-9 m-0 float-right">
                        <div class="row p-0">
                            <div class="col-4 mt-3 p-0" style="text-align: center;">
                                <h6 *ngIf="totalRecordsForPagination != 0">{{totalRecordsForPagination}} records found</h6>
                            </div>
                            <div class="col-8 p-0 m-0" *ngIf="totalPages > 1">
                                <app-pagination [totalPages]="totalPages" [currentPage]="currentPage" (pageChanged)="GetMissedActionData($event)">
                                </app-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
<app-loader [showLoader]="showLoader"></app-loader>
<notifier-container></notifier-container>
